<template>
    <div class="uploadPage">
        <div class="title">
            <p></p>
            <h4>上传客户已盖章投保单</h4>
        </div>
        <div class="matter">
            <div class="fileContent">
                <p>上传客户已盖章投保单:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="10"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf,.png,.jpg,.zip,.rar"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="upload_data"
                    :file-list="insureList"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
        <div class="preserve">
            <el-button @click="saveBtn">保存</el-button>
            <el-tooltip class="item" effect="dark" content="确认完成上传，等待保险公司上传收款信息" placement="top">
                <el-button @click="verifyBtn">确认上传</el-button>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import { confirmUploadInsure, saveSealedInsure, viewsealedInsure } from '../../../api/insure';

    export default {
        name: 'uploadSealedInsure',
        data(){
            return{
                url:process.env.VUE_APP_BASE_API+'/api/upload_toubaodan_file',
                headers:{
                    "Authorization": sessionStorage.getItem("token")
                },
                upload_data:{
                    case_id:'',
                    doc_type:'77',  //客户已盖章投保单
                },
                insure_file:[],
                insureList:[]
            }
        },
        methods:{
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            //删除
            handleRemove(file, fileList){
                let arr = [];
                fileList.forEach(res => {
                    if (!res.response) {
                        arr.push(res.psd_code);
                    } else {
                        arr.push(res.response.data.psd_code);
                    }
                });
                this.insure_file = arr;
            },
            //上传成功
            handleSuccess(response, file, fileList){
                if (response.code==200){
                    if (response.data.doc_type==77){
                        this.insure_file.push(response.data.psd_code)
                    }
                    this.$message.success(response.msg)
                }else {
                    this.$message.error(response.msg)
                }
            },
            //限制上传个数
            handleExceed(files, fileList){
                if (fileList.length>=10){
                    this.$message.error('只能上传10个文件');
                }
            },
            //保存
            saveBtn(){
                let data={
                    case_id:this.$route.query.id,
                    toubaodan_psd_codes:this.insure_file
                }
                saveSealedInsure(data).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            },
            //确认上传
            verifyBtn(){
                this.$confirm('请确认已上传盖过章的投保单 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    confirmUploadInsure({case_id:this.$route.query.id}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg)
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });
            }
        },
        created() {
            this.upload_data.case_id=this.$route.query.id
            viewsealedInsure({case_id:this.$route.query.id}).then(res=>{
                if (res.code==200){
                    if (res.data.toubaodan_list!=''&&res.data.toubaodan_list!=undefined){
                        res.data.toubaodan_list.map(res=>{
                            this.insureList.push(res)
                            this.insure_file.push(res.psd_code)
                        })
                    }
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .uploadPage{
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
        min-width: 95% !important;
        width: max-content;
    }
    .title{
        display: flex;
        align-items: center;
        color: #3e62f6;
    }
    .title>p{
        width: 5px;
        height: 18px;
        background-color: #3e62f6;
        margin-right: 10px;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 50px 25px;
    }
    .custom{
        background-color: #3f5cf7;
        color: #fff;
    }
    /deep/.el-input__inner{
        color: #878889 !important;
    }
    /deep/.el-form-item__content{
        height: 32px;
        align-items: center;
    }
    /deep/.el-form-item__content{
        display: flex;
    }
    /deep/.el-input--small,
    /deep/.el-input__inner{
        width: 250px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    /deep/.el-upload--text{
        margin: 0px 20px;
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .preserve{
        width: 100%;
        text-align: center;
    }
    .preserve>button{
        width: 120px;
        background-color: #3b63f6;
        color: #fff;
        height: 40px;
        border-radius: 5px;
    }

    /deep/.el-upload-list{
        display: flex;
        align-items: flex-end;
    }
</style>
